import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("sb_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("sb_cart", JSON.stringify(items));
  }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const exists = prev.find((x) => x.id === product.id);
      if (exists) return prev.map((x) => x.id === product.id ? { ...x, quantity: x.quantity + qty } : x);
      return [...prev, { id: product.id, title: product.title, price: product.price, image: product.images?.[0], vendor_name: product.vendor_name, quantity: qty }];
    });
  }, []);

  const remove = useCallback((id) => setItems((p) => p.filter((x) => x.id !== id)), []);
  const update = useCallback((id, qty) => setItems((p) => p.map((x) => x.id === id ? { ...x, quantity: Math.max(1, qty) } : x)), []);
  const clear = useCallback(() => setItems([]), []);

  const value = useMemo(() => {
    const total = items.reduce((s, x) => s + x.price * x.quantity, 0);
    const count = items.reduce((s, x) => s + x.quantity, 0);
    return { items, add, remove, update, clear, total, count };
  }, [items, add, remove, update, clear]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
